import { API, authH } from "@/api";
export { API, authH };
/**
 * Shared helpers for the PMS Queue admin panels.
 * Batch #14.154 — Refactor: split AdminPmsQueuePage.jsx into modular panels.
 */


export function b64ToBlob(b64, mime) {
  const byteChars = atob(b64);
  const byteArrays = [];
  for (let i = 0; i < byteChars.length; i += 1024) {
    const slice = byteChars.slice(i, i + 1024);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) byteNumbers[j] = slice.charCodeAt(j);
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return new Blob(byteArrays, { type: mime });
}
